import React from 'react';
import TextField from '@hid-galaxy-ui/galaxy-react/components/TextInput';
import { makeStyles } from '@material-ui/core/styles';
import cx from 'classnames';

import './InputText.module.scss';
import classNames from 'classnames';
import { getLabel } from '../../../utils/FormDataMappers';

const useInputStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    // maxWidth: theme.custom.inputs.maxWidth,
    // marginBottom: theme.spacing(5),
  },
}));

const InputText = (props) => {
  const classes = useInputStyles();
  const {
    field,
    form,
    value,
    required,
    label,
    hint,
    type,
    istouched,
    propsHasError = false,
    className,
  } = props;
  const { name: fieldName, value: fieldValue } = field || {};
  const { errors, setFieldValue, setErrors, setFieldError, touched } = form || {};
  const fieldError = fieldName && errors && errors[fieldName] ? errors[fieldName] : null;
  const hasError = Boolean(fieldError) || propsHasError;
  const helperText = fieldError || hint;
  const inputValue = fieldValue || value;

  const shouldDisplayError = () => touched[fieldName] && !!errors[fieldName];

  const handleChange = (event) => {
    const newValue = event.target.value;

    if (fieldName && setFieldValue) {
      // setFieldError(fieldName, undefined);
      // setErrors((prev) => {
      //   console.log('prev', prev);
      //   return { ...prev, [fieldName]: undefined };
      // });

      setFieldValue(fieldName, newValue);
    } else if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className={className}>
      <TextField
        {...props}
        helperText={shouldDisplayError() ? helperText : ''}
        isRequired={required}
        label={label}
        variant="outlined"
        color="primary"
        className={cx(classes.root)}
        size="small"
        status={shouldDisplayError() ? 'error' : undefined}
        onChange={handleChange}
        value={inputValue}
        type={type}
        // wrapperClass={className}
      />
    </div>
  );
};

export default InputText;
